import { useState } from 'react';
import s from './Faq.module.scss';

const faqs = [
  // {
  //   question: '初心者でも参加できますか？',
  //   answer: 'はい、初めての方でも安心してご参加いただけます。ツアー前に丁寧にレクチャーし、当日もペースに合わせてご案内します。',
  // },
  {
    question: '写真や動画はもらえますか？',
    answer: '撮影データは当日AirDropにてお渡し可能です。編集が必要なデータについては、1日以内にオンラインダウンロードURLをお送りします。',
  },
  // {
  //   question: 'どんな方におすすめですか？',
  //   answer: '私が提供するツアーはすべて映えたい方向けに特化したツアーになります。',
  // },
  {
    question: '送迎はありますか？',
    answer: 'はい、宮古島内であれば基本的にどこでも送迎可能です。ご予約時に宿泊先や集合場所をお知らせください。',
  },
  {
    question: '雨の日はどうなりますか？',
    answer: '当日の海況や天候を確認したうえで、十分な撮影クオリティでご案内することが難しいと判断した場合は、ツアーを中止または日程変更とさせていただく場合がございます。その際のキャンセル料は発生いたしません。',
  },
  {
    question: '年齢制限はありますか？',
    answer: 'サーフィン体験以外は、ツアーの世界観や体験コンセプト維持のため、20歳〜40歳の方を対象とさせていただいております。',
  },
  {
    question: '子供も参加できますか？',
    answer: '申し訳ありません。サーフィン体験以外は、大人向けの体験・撮影をコンセプトとしているため、お子様のご参加はご遠慮いただいております。',
  },
  {
    question: '支払いはいつですか？',
    answer: 'お支払いはツアー当日にお願いいたします。ツアーにご満足いただけなかった場合はお支払い不要です。',
  },
];

const WaveIcon = () => (
  <svg className={s.wave} viewBox="0 0 58 10">
    <path d="M1 5C5 1 9 1 13 5C17 9 21 9 25 5C29 1 33 1 37 5C41 9 45 9 49 5C52 2 55 2 57 5" />
  </svg>
);

const Faq = ({ items = faqs }) => {
  const [openIndex, setOpenIndex] = useState(0);
  const faqItems = items.length > 0 ? items : faqs;

  return (
    <section className={s.root}>
      <div className={s.head}>
      <h2 className={s.title}>
        よくある質問
        <WaveIcon />
      </h2>
      </div>

      <div className={s.list}>
        {faqItems.map((faq, index) => {
          const isOpen = openIndex === index;

          return (
            <div className={`${s.item} ${isOpen ? s.open : ''}`} key={faq.question}>
              <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)}>
                <span>0{index + 1}</span>
                {faq.question}
                <svg viewBox="0 0 24 24">
                  <path d="M6 9l6 6 6-6" />
                </svg>
              </button>

              <div className={s.answer}>
                <p>{faq.answer}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Faq;
